import React, { useRef, useEffect, useState } from 'react';
import { draggable } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { Alphabet } from './../utils/constants';

function ImageItem({ message, secretCode, newMessage }) {
    const srcImage = message.pic;
    const text = message.pic.split("image/upload/")[1].slice(0, -4); 
    secretCode = secretCode && secretCode.replace(/ /g, '_');
    const [decodedSrc, setDecodedSrc] = useState(message.pic);
    var isImageInitial = srcImage && (srcImage.startsWith('https://res.cloudinary.com/dvxtz') || srcImage.startsWith('http://res.cloudinary.com/dvxtz'));
    const [isError, setIsError] = useState(false);
    const filterContent = (text) => {
        let cleaned = text.replace(/<\s*script\b[^>]*>.*?<\s*\/\s*script\s*>/gmi, '');
        cleaned = cleaned.replace(/on\w+\s*=\s*['"][^'"]*['"]/gmi, ''); 
        return cleaned
    };
    const numAlph = {};
    for(let i=0; i<Alphabet.length; i++) {
        numAlph[Alphabet[i]] = i;
    }
    
    useEffect(() => {
        if(isError && message.content === newMessage) {
            let contentToDisplay = '';
            if (secretCode) {
                try {
                    for (let i = 0; i < text.length; i++) {
                        contentToDisplay += Alphabet[(numAlph[text[i]] - numAlph[secretCode[i % secretCode.length]] + Alphabet.length) % Alphabet.length];
                    }
                } catch (e) {
                    console.error("Decryption failed:", e);
                    contentToDisplay = "Decryption Error";
                }
            } else {
                contentToDisplay = text; 
            }
            let safeContent = filterContent(contentToDisplay);
            safeContent = safeContent.replace(/>/g, ' ');
            setDecodedSrc("https://res.cloudinary.com/dvxtzwyam/image/upload/" + safeContent);
        }
    }, [srcImage, secretCode, newMessage]);
    useEffect(() => {
        setIsError(false);
    }, [decodedSrc]);
    if (isError || !decodedSrc) {
             return  (
                    <span className='absentImage'>
                        <img alt='encrypted' key={message._id} src= "./images/logo512.png" loading="lazy" />
                        <span> ENCRYPTED </span>
                    </span>    
             )
    }
    return (
        <img    alt='chatpicture' 
                key={message._id} 
                src={decodedSrc} 
                onError={() => setIsError(true)}
                loading="lazy"
            
        />
    )
}


export default ImageItem;